
import Vue, { PropType } from 'vue';
import { Client, Site } from '@/interfaces/multiTenancy';
import { AnnotatedLocal } from '@/i18n/interfaces/locales';
import SideBarSvgIcon from '@/assets/icons/Sidebar.svg';

/*
	All known language selection messages. This section is picked up by vue-i18n. DO NOT REMOVE.

	// Language messages
	this.$t('en-gb');
	this.$t('fr');
*/

export default Vue.extend({
	components: {
		SideBarSvgIcon,
	},

	props: {
		activeLocale: { type: String },
		client: { type: Object as PropType<Client> },
		site: { type: Object as PropType<Site> },
		supportedLocales: { type: Array as PropType<AnnotatedLocal[]> },
		showSideBarButton: { type: Boolean },
		backgroundColor: { type: String, default: 'primary' },
		textColor: { type: String, default: 'light' },
		userClients: { type: Array as PropType<Client[]> },
		clientSites: { type: Array as PropType<Site[]> },
	},
	methods: {
		navigation(routeName: string): void {
			this.$emit('navigation', routeName);
		},

		tempSenseRedirection(): void {
			this.$emit('redirectToTempSense');
		},

		logOut(): void {
			this.$emit('logout');
		},

		sideBarToggled(): void {
			this.$emit('sideBarToggled');
		},

		changeLocale(languageCode: string): void {
			this.$emit('changeLocale', languageCode);
		},
		async changeClient(client: Client) {
			this.$emit('changeClient', client);
		},
		async changeSite(site: Site) {
			this.$emit('changeSite', site);
		},
	},
});
